/* eslint-disable react/no-array-index-key */
import React, { type ReactNode } from 'react';
import cx from 'classnames';
import Icon from '@components/Icon';
import ItemIcon from './img-arrow.png';

function LibModalNav<T extends readonly { id: string; name: string }[]>({
  navItems,
  children,
  selected,
  onChange,
}: {
  navItems?: T;
  selected?: T[number]['id'];
  onChange?: (val: T[number]['id']) => void;
  children?: ReactNode;
}) {
  return (
    <div style={{ width: 220 }} className="border-r">
      {!!navItems && (
        <div className="border-b pt-20 pb-20 pr-20">
          {navItems.map((x, i) => (
            <div
              key={i}
              className={cx(
                'flex h-40 cursor-pointer items-center rounded px-10',
                {
                  'bg-blue text-white': x.id === selected,
                }
              )}
              onClick={() => {
                if (x.id !== selected) onChange?.(x.id);
              }}
            >
              {x.name}
              <Icon src={ItemIcon} className="ml-auto" />
            </div>
          ))}
        </div>
      )}
      {children}
    </div>
  );
}

export default LibModalNav;
